import { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import {
  PlanPricingContractTable,
  PaymentModelPricingTablesFactory,
} from '@components/Order/Numbers/Tables';
import { Page500 } from '@containers/ErrorPages';
import { AutoScrollToQuery } from '@features/AutoScrollTo';
import { planDetailsApi } from '@reducers/plan/plan';
import { skipToken } from '@reduxjs/toolkit/query';

export const PricingTab = () => {
  const contentElem = useRef(null);
  const { payment_model: paymentModel } = useSelector(
    (state) => state.auth.user
  );
  const { showState } = useSelector((state) => state.plan.planInfo);
  const queryArg =
    showState.currentPlan.id && showState.currentPlan.type
      ? { ...showState.currentPlan }
      : skipToken;
  const pricingQuery = planDetailsApi.useGetPricingQuery(queryArg);

  if (pricingQuery.isLoading || pricingQuery.isFetching) {
    return (
      <div ref={contentElem}>
        <DefaultSpinnerCenter />
        <AutoScrollToQuery query={pricingQuery} ref={contentElem} />
      </div>
    );
  }
  if (pricingQuery.isError) {
    return <Page500 />;
  }
  const PlanPricingTable = new PaymentModelPricingTablesFactory(
    paymentModel,
    showState.currentPlan.type
  ).getTableClass();
  return (
    <div ref={contentElem}>
      <Row>
        <PlanPricingTable data={[pricingQuery.data.nonUsage]} />
      </Row>
      <Row>
        <Col md={4}>
          <PlanPricingContractTable data={[pricingQuery.data.contract]} />
        </Col>
      </Row>
      <AutoScrollToQuery query={pricingQuery} ref={contentElem} />
    </div>
  );
};
